'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import ProjectGchpController from './controller/projectGchp';

import ProjectGchpTableDirective from './directive/projectGchpTable';
import ProjectGchpFilterDirective from './directive/projectGchpFilter';
import ProjectGchpTableRowDirective from './directive/projectGchpTableRow';
import ProjectGchpService from './service/projectGchp';
import ProjectGchpFilterService from './service/filter';

export default angular.module('investmentProject.project-gchp', [])
    .controller('ProjectGchpController', ProjectGchpController)
    .directive('projectGchpTable', ProjectGchpTableDirective)
    .directive('projectGchpTableRow', ProjectGchpTableRowDirective)
    .directive('projectGchpFilter', ProjectGchpFilterDirective)
    .factory('ProjectGchpService', ProjectGchpService)
    .factory('ProjectGchpFilterService', ProjectGchpFilterService)
.name;
